import {Component} from '@angular/core';
import {ModalService} from "./modal.service";

@Component({
    selector: 'modal',
    providers: [],
    templateUrl: './modal.component.html'
})
export class ModalComponent {

    constructor(private modalService: ModalService){

    }

    getModal(){
        return this.modalService;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/root/modal/modal.component.ts